module.exports = __webpack_public_path__ + "static/media/overview7_0.6d4a1e45.png";